import i18next from 'i18next';

export const getPhilosophyTextsList = () => {
  const textsList = i18next.t('investmentsPage.philosophyTextsList', {
    returnObjects: true,
  }) as Array<{ id: number; label: string; description: string }>;

  return textsList;
};
